import { getLiveContextData } from './instantLoaded/tools';
import { _get } from './lodashReplacement';

export const getValueFromLocalStorage = async (path: string) => {
  // 读取并删除历史记录
  const savedStorage = await getLiveContextData();

  if (!savedStorage) {
    return '';
  }

  // 解析数据
  let parsedSavedHistory = {};
  try {
    parsedSavedHistory = JSON.parse(savedStorage);
  } catch (err) {}

  return _get(parsedSavedHistory, path);
};
